const r = {
  name: "ArrowCircleUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 10.4143L15.9998 13.4142L17.4141 12L11.9998 6.58576L6.58564 12L7.99985 13.4142L11 10.414V17H13V10.4143Z" fill="currentColor"/>
<path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="currentColor"/>
</svg>
  `
};
export {
  r as ArrowCircleUp
};
